import { createSlice } from '@reduxjs/toolkit';

const vesselSlice = createSlice({
  name: 'vessel',
  initialState: {
    selectedVesselId: null,
  },
  reducers: {
    setSelectedVessel: (state, action) => {
      state.selectedVesselId = action.payload;
    },
  },
});

export const { setSelectedVessel } = vesselSlice.actions;
export default vesselSlice.reducer;
